module.exports = __webpack_public_path__ + "img/amg.5a2053b0.jpg";